"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getToken = exports.removeToken = exports.saveToken = void 0;
const saveToken = (token) => {
    localStorage.setItem("token", token);
};
exports.saveToken = saveToken;
const removeToken = () => {
    localStorage.removeItem("token");
};
exports.removeToken = removeToken;
const getToken = () => {
    return localStorage.getItem("token");
};
exports.getToken = getToken;
